import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'lib-uw-button',
  templateUrl: './uw-button.component.html',
  styleUrls: ['./uw-button.component.scss']
})
export class UwButtonComponent implements OnInit {
  @Output() tap = new EventEmitter();
  @Input() text: string;
  @Input() tabIndex: string;
  @Input() showLoader = false;
  @Input() disableButton = false;
  @Input() alternateTheme = false;
  @Input() cssClass;
  @Input() buttonType = '';
  @Input() ariaMsg: string;
  @Input() showAria = false;
  @Input() setFocusOnButton = false;
  constructor() { }

  ngOnInit() {
  }
  onClick(): void {
    this.tap.emit();
  }
  getID() {
    return this.text ? this.text.replace(/ /g, '_').toLowerCase() : '';
  }
}
